import Img2 from "../images/testimonials/pfp1.jpg";
import Img3 from "../images/testimonials/pfp2.jpg";
import { db } from "./firebase.js";
import { getDocs, collection } from "firebase/firestore";
import { useState, useEffect } from "react";
import image1 from "../images/plan/r1.jpeg";
import image2 from "../images/plan/r2.jpeg";
import image3 from "../images/plan/r3.jpeg";
import image4 from "../images/plan/r4.jpeg";
import image5 from "../images/plan/r5.jpeg";
import image6 from "../images/plan/r6.jpeg";

function Testimonials() {

  const images = [
    { src: image1 },
    { src: image2 },
    { src: image3 },
    { src: image4 },
    { src: image5 },
    { src: image6 },
  ];



  return (
    <>
      <section className="testimonials-section">
        <div className="container">
          <div className="testimonials-content">
            <div className="testimonials-content__title">
              <h4>Reviewed by People</h4>
              <h2>Client's Testimonials</h2>
              <p>
              Discover the positive impact of our ATV rental services through glowing client testimonials. Offering both public and private rentals in Providenciales, we’ve earned a reputation for reliability and affordability. Join our satisfied customers for a seamless and unforgettable adventure. Choose us for your next journey!
              </p>
            </div>

            <div className="container mt-4" >
          <div className="row" style={{marginTop:'20px'}}>
            {images.map((image, index) => (
              <div className="col-12 col-md-3 mb-3" key={index}>
                <img
                  src={image.src}
                  alt={`Testimonial Image ${index + 1}`}
                  className="img-fluid w-100"
                />
              </div>
            ))}
          </div>
        </div>


          </div>



        </div>
      </section>
    </>
  );
}

export default Testimonials;
